// extracted by mini-css-extract-plugin
export default {"container":"style_container__tmRSB","tabLink":"style_tabLink__idQX8"};